export default __webpack_public_path__ + "static/media/lottery-banners.61f1d0dc.webp";